module.exports = __webpack_public_path__ + "img/jkr-logo.ea2dcbeb.png";